import { forwardRef, ReactNode } from "react";
import { Field } from "formik";

import FormikErrorMessage from "../FormikErrorMessage";

import { FieldTypes, getPlaceholderText, renderFormLabel } from "./constants";
import * as styledElements from "./FormikFormLineStyles";

interface FormikFormLineProps {
  name: string;
  label?: string;
  labelComponent?: ReactNode;
  type?: FieldTypes;
  isRequired?: boolean;
  isTextArea?: boolean;
  styleProps?: object;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  errorMessage?: string;
}

const FormikFormLine = forwardRef<HTMLInputElement, FormikFormLineProps>(
  function FormikFormLine(
    {
      name,
      label,
      labelComponent,
      type = FieldTypes.text,
      isRequired = true,
      isTextArea = false,
      styleProps,
      placeholder,
      disabled,
      autoFocus,
      errorMessage,
    },
    ref,
  ) {
    return (
      <styledElements.Container
        isDateField={type == FieldTypes.date}
        style={{ ...styleProps }}
      >
        {renderFormLabel(name, label, labelComponent)}
        <Field
          autoFocus={autoFocus}
          as={isTextArea ? "textarea" : ""}
          type={type}
          id={name}
          name={name}
          placeholder={getPlaceholderText(isRequired, placeholder)}
          disabled={disabled}
          innerRef={ref}
        />
        <FormikErrorMessage name={name} errorMessage={errorMessage} />
      </styledElements.Container>
    );
  },
);

export default FormikFormLine;
